import axios from "axios";
import {subscribeWebsocket1} from "../../../../reducers/websocket";

//const
const EQUIPMENT_DATA_VIEW_UPDATE_DATA = "equipmentDataView/EQUIPMENT_DATA_VIEW_UPDATE_DATA";
const EQUIPMENT_DATA_VIEW_STORE_NODE = "equipmentDataView/EQUIPMENT_DATA_VIEW_STORE_NODE";
const EQUIPMENT_DATA_VIEW_STORE_DATA = "equipmentDataView/EQUIPMENT_DATA_VIEW_STORE_DATA";
const EQUIPMENT_DATA_VIEW_TOGGLE_LOADING = "equipmentDataView/EQUIPMENT_DATA_VIEW_TOGGLE_LOADING";

//reducer
export const equipmentDataView = (state = {

  loading: false,
  equipmentId: "",
  equipmentData: [],
}, action) => {
  switch (action.type) {
    case EQUIPMENT_DATA_VIEW_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_DATA_VIEW_STORE_NODE:
      return {
        ...state,
        equipmentData: action.data.map(d => {
          d.switch = false;
          return d;
        }),
        loading: false
      };
    case EQUIPMENT_DATA_VIEW_STORE_DATA: {
      let newData = state.equipmentData.slice(0);
      newData.forEach((item, index) => {
        if (item.switch && item.name === action.data.name) {
          item.value = action.data.value;
          item.timestamp = action.data.timestamp;
          item.quality = action.data.quality;
        }
      });
      console.log("0002", newData);
      return {
        ...state,
        equipmentData: newData,
        loading: false
      };
    }
    case EQUIPMENT_DATA_VIEW_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateEquipmentDataViewData = (data) => {
  return {
    type: EQUIPMENT_DATA_VIEW_UPDATE_DATA,
    data: data
  }
};

export const startKafkaListener = (topic) => (dispatch) => {
  dispatch(toggleLoading(true));
  dispatch(updateEquipmentDataViewData({
    name: "equipmentId",
    value: topic
  }));
  axios.get(`/api-equipment/getNodeConfigByEquipmentId/${topic}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentNode(response.data));
        dispatch(toggleLoading(true));
        axios({
          url: `/api-equipment/kafka/start?topic=${topic}`,
          method: "POST"
        }).then(
          response => {
            dispatch(subscribeWebsocket1(`/kafka/dataset/${topic}`,
              message => {
                console.log("kafka message:", message.body);
                dispatch(storeEquipmentData(JSON.parse(message.body)));
              })
            );
          }
        ).catch(
          err => {
            console.error("ERROR: start kafka failed", err);
          }
        );
      }
    }
  );
};

export const stopKafkaListener = (topic) => (dispatch) => {
  axios({
    url: `/api-equipment/kafka/stop?topic=${topic}`,
    method: "POST"
  })
};

// /**
//  * check and init equipment data
//  */
// export const initEquipmentData = (data) => (dispatch) => {
//   let equipmentId = data.equipmentId;
//   if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
//     dispatch(toggleLoading(true));
//     axios.get(`/${equipmentId}`, {contentType: "application/json"}).then(
//       response => {
//         dispatch(toggleLoading(false));
//         if (response.data) {
//           dispatch(storeEquipmentData(response.data));
//         } else {
//           dispatch(storeEquipmentData([]));
//         }
//       }
//     );
//   } else {
//     dispatch(toggleLoading(false));
//     browserHistory.push("/exception/415");
//   }
// };
/**
 * store all equipment node
 */
export const storeEquipmentNode = (equipmentNode) => {
  return {
    type: EQUIPMENT_DATA_VIEW_STORE_NODE,
    data: equipmentNode
  }
};

/**
 * store all equipment data
 */
export const storeEquipmentData = (equipmentData) => {
  return {
    type: EQUIPMENT_DATA_VIEW_STORE_DATA,
    data: equipmentData
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_DATA_VIEW_TOGGLE_LOADING,
    data: show
  }
};

